import { styled } from "@mui/material/styles";
import { Grid, Link, Typography } from "@mui/material";

export const Root = styled("div")(() => ({
  padding: "35px 0 100px",
}));

export const StyledGrid = styled(Grid)(({ theme }) => ({
  marginBottom: 53,
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 95,
  },
}));

export const GroupTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "categoryColor",
})(({ theme, categoryColor }) => ({
  padding: "30px 0 20px",
  textTransform: "uppercase",
  textAlign: "center",
  ...(categoryColor && { color: theme.palette.categories[categoryColor] }),
  [theme.breakpoints.up("mobile")]: {
    padding: "30px 0 36px",
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  display: "block",
  textAlign: "center",
  fontSize: theme.typography.large.fontSize,
}));
